// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2bi1H","imageUploader":"EGiftCard_imageUploader__2Jjh0"};